import { cookieName } from '@/configs/cookie';

export default function getCookieName(name: string) {
  return `${cookieName}_${name.toUpperCase()}`;
}
